import { UpdateOrganizationComponent } from './update-organization/update-organization.component'
import { CreateOrganizationComponent } from './create-organization/create-organization.component'
import { OrganizationsComponent } from './organizations.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const organizationsRoutes: Routes = [
  {
    path: 'admin/registrations',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'ORGANIZATIONS',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: OrganizationsComponent,
        data: {
          permissions: {
            only: 'ORGANIZATIONS',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateOrganizationComponent,
        data: {
          permissions: {
            only: 'ORGANIZATIONS',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateOrganizationComponent,
        data: {
          permissions: {
            only: 'ORGANIZATIONS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
